import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import { t } from '~/helpers';
import api from '~/services/api';

import SelMovimentacaoPitStop from './form';

const formRef = createRef();

class SelMovimentacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      params: {},
      show: false,
      gravando: false,
      movimentacoes: [],
      tam: 'md',
    };
  }

  buscaMovimentacoes = async (idturno, idposto, idveiculo, origem) => {
    try {
      const url =
        origem === 'A'
          ? `pitstop/abastecimento/${idturno}/${idposto}/${idveiculo}`
          : `pitstop/lubrificacao/${idturno}/${idposto}/${idveiculo}`;
      const { data } = await api.get(url);
      const list = data.movimentacoes.map((movimentacao) => ({
        ...movimentacao,
      }));
      await this.setState((prevState) => ({
        ...prevState,
        show: true,
        movimentacoes: list,
      }));
    } catch (error) {
      toast.error('Erro ao acessar dados');
    }
  };

  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  async handleCloseModal() {
    await this.setState({ open: false, gravando: false });
    this.props.close();
  }

  async hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
      gravando: false,
    }));
    this.props.close();
  }

  async handlesub() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
    await formRef.current.submitForm();
  }

  async submeteForm(event) {
    this.setState((prevState) => ({
      ...prevState,
      gravando: true,
    }));
    formRef.current.submitForm(event);
  }

  async finalizaGravacao() {
    this.setState((prevState) => ({
      ...prevState,
      gravando: false,
    }));
  }

  async alteraTamanho(novoTamanho) {
    this.setState((prevState) => ({
      ...prevState,
      tam: novoTamanho,
    }));
  }

  handleSelecionaMovimentacao = async (idmovimentacao) => {
    this.props.seleciona(idmovimentacao, this.state.params.origem);
    this.handleCloseModal();
  };

  render() {
    const { open, tam, params } = this.state;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth={tam}
        open={open}
        onClose={() => this.handleCloseModal()}
        fullScreen={window.innerWidth <= 600}
      >
        <DialogTitle>
          <Typography variant="h6">
            {this.state.params.origem === 'A'
              ? t('s.cadastro.pitstop.abastecimento')
              : t('s.cadastro.pitstop.lubrificacao')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <SelMovimentacaoPitStop
            data={params}
            reference={formRef}
            seleciona={this.handleSelecionaMovimentacao}
            close={() => {
              this.handleCloseModal();
              this.props.update(params);
            }}
            cancelarAcao={() => this.hancleCancelarAcao()}
            finalizaGravacao={() => this.finalizaGravacao()}
            alteraTamanho={(tam) => this.alteraTamanho(tam)}
          />
        </DialogContent>
        <DialogActions>
          {this.state.movimentacoes.length === 0 && (
            <Button
              startIcon={<Check />}
              color="primary"
              variant="outlined"
              onClick={(event) => this.submeteForm(event)}
              disabled={this.state.gravando}
            >
              {t('s.geral.botaoconfirmar')}
            </Button>
          )}
          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => this.handleCloseModal()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(SelMovimentacao);
